module.exports = __webpack_public_path__ + "images/a7e5422670b61d7244aef3d5be8df024.png";